// TintiCloud — Usuário logado & notificações. Dados de demonstração.
export const currentUser = {
  name: "Luiz Tinti",
  email: "luiz@tinticloud.com",
  role: "Administrador",
  initials: "LT",
};

export const notifications = [
  { id: "n1", tone: "err", title: "Backup falhou", desc: "primeagents · sv4", time: "há 2 min" },
  { id: "n2", tone: "warn", title: "SSL expira em breve", desc: "moracomigo.com.br · 8 dias", time: "há 20 min" },
  { id: "n3", tone: "info", title: "Deploy concluído", desc: "TintiCloud · production", time: "há 1 h" },
  { id: "n4", tone: "ok", title: "Certificado renovado", desc: "c2desk.com.br", time: "há 2 h" },
];
